import Hotjar from "@hotjar/browser";

import { checkCookieConsent, generateRandomId, getEnvironment, getLocalKlimVar, setLocalKlimVar, trackMixpanel } from "utils";

const initFBSDK = () => {
  const script = document.createElement("script");
  script.src = "https://connect.facebook.net/en_US/sdk.js";
  script.referrerpolicy = "origin";
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  window.fbAsyncInit = function () {
    window.FB.init({
      appId: "410760340429351",
      xfbml: true,
      version: "v12.0",
    });
    window.FB.AppEvents.logPageView();
  };
};

const initGoogleTagManager = () => {
  // Google Tag Manager setup
  const w = window;
  const d = document;
  const s = "script";
  const l = "dataLayer";
  const i = "GTM-WNL2LW3";
  w[l] = w[l] || [];
  w[l].push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  // Create and insert the GTM script tag as the first script in the head
  const head = d.getElementsByTagName("head")[0];
  const j = d.createElement(s);
  const dl = l !== "dataLayer" ? `&l=${l}` : "";
  j.async = true;
  j.src = `https://sst.klim.eco/gtm.js?id=${i}${dl}`;

  // Find the first script tag in the head and insert the GTM script before it
  const scriptsInHead = head.getElementsByTagName(s);
  if (scriptsInHead.length > 0) {
    head.insertBefore(j, scriptsInHead[0]);
  } else {
    head.appendChild(j);
  }

  // Google Tag Manager (noscript) setup
  const noscript = d.createElement("noscript");
  const iframe = d.createElement("iframe");
  iframe.src = `https://sst.klim.eco/gtm.js?id=${i}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";

  noscript.appendChild(iframe);

  // Insert the noscript tag as the first element in the body
  const body = d.getElementsByTagName("body")[0];

  if (body.childNodes.length > 0) {
    body.insertBefore(noscript, body.firstChild);
  } else {
    body.appendChild(noscript);
  }
};

const initHotjar = () => {
  const SITE_ID = 5211850;
  const HOTJAR_VERSION = 6;

  Hotjar.init(SITE_ID, HOTJAR_VERSION);
};

export const initAnalytics = () => {
  const env = getEnvironment();
  const allCookiesAccepted = checkCookieConsent();
  sessionStorage.setItem("Mixpanel_session", false);

  // we want to always init tracking/cookies in the app
  // on web, only init tracking/cookies users who have accepted cookies
  if (env.app || (!env.app && allCookiesAccepted)) {
    if (env.app) {
      document.addEventListener("deviceready", () => {
        initFBSDK();
      });
    }
    if (env.production) {
      initGoogleTagManager();
      initHotjar(); // we only want to record sessions with hotjar in production
    }
    if (env.staging) {
      initGoogleTagManager();
    }
  }

  if (env.production || env.staging) {
    if (!getLocalKlimVar("sessionId")) {
      setLocalKlimVar("sessionId", generateRandomId());
    }
    trackMixpanel("StartSession");
  }
};
